import { normalize } from 'normalizr';
import httpActions from 'actions/httpActions/httpActions';
import { refreshAccessToken } from 'actions/authActions/authActions';
import { logError } from 'utils/tools/tools';
import fetch from 'isomorphic-fetch';

export const CALL_API = 'CALL_API';

export const actionWith = (action, data) => {
  const newAction = Object.assign({}, action, data);
  delete newAction[CALL_API];
  return newAction;
};

export const refreshAccessTokenThenRetryRequest = ({ requestName, store, action, next }) => {
  next(httpActions.requestRetry(requestName));
  const retries = store.getState().http.getIn([requestName, 'retries'], 0);
  if (retries <= 3) {
    next(refreshAccessToken(action));
  } else {
    throw new Error(`${requestName}: Maximum number of retries exceeded`);
  }
};

export const processApiCall = ({ store, action, next, callAPI }) => {
  const { endpoint, requestName, schema, types, requestOptions } = callAPI;
  const [requestType, successType, failureType] = types;
  const returnHeaders = callAPI.returnHeaders || [];

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.');
  }

  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.');
  }

  next({ type: requestType });
  next(httpActions.requestMade(requestName));

  const reqOptions = Object.assign({ credentials: 'same-origin' }, requestOptions);

  if (reqOptions.method === 'POST' || reqOptions.method === 'PUT') {
    reqOptions.body = JSON.stringify(reqOptions.formData);
    reqOptions.headers = Object.assign({
      Accept: 'application/json, text/javascript, *.*',
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    }, requestOptions.headers);
  }

  return fetch(endpoint, reqOptions)
    .then((response) => {
      if (!response.ok) {
        if (response.status === 401) {
          refreshAccessTokenThenRetryRequest({ requestName, store, action, next });
        }
        return Promise.reject(response.statusText);
      }
      return response;
    })
    .then((response) => response.json().then((json) => ({ json, response })))
    .then(({ json, response }) => ({
      json: schema ? Object.assign({}, normalize(json, schema)) : json,
      headers: response.headers,
    }))
    .then((response) => {
      const headers = {};

      returnHeaders.forEach((headerName) => {
        headers[headerName] = response.headers.get(headerName);
      });

      const actionObj = {
        response: Object.assign(response.json, { headers }),
        type: successType,
      };

      next(actionWith(action, actionObj));
      next(httpActions.requestSuccess(requestName));
    })
    .catch((error) => {
      next(actionWith(action, {
        type: failureType,
        error: error.message || 'no error message returned',
      }));
      next(httpActions.requestError(requestName));

      logError(error, { url: endpoint });

      return Promise.reject(error);
    });
};

export default (store) => (next) => (action) => {
  const callAPI = action[CALL_API];

  return (typeof callAPI === 'undefined') ?
    next(action) :
    processApiCall({ store, action, next, callAPI });
};



// WEBPACK FOOTER //
// ./middlewares/apiMiddleware/apiMiddleware.js